// Class and Hook versions of FormManager
import _default from './FormManager';
export { _default as default };
import _useFormManager from './useFormManager';
export { _useFormManager as useFormManager };

// Development utilities

import _FieldsTestOutput from './tools/FieldsTestOutput';
export { _FieldsTestOutput as FieldsTestOutput };
import _logFormData from './tools/logFormData';
export { _logFormData as logFormData };

// Date utilities; may be useful beyond form value formatting

import _formatDate from './formatters/formatDate';
export { _formatDate as formatDate };

export { toMoment } from './formatters/formatDate';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@allpro/form-manager/es/index.js
// module id = 175
// module chunks = 0